import { render, staticRenderFns } from "./approveExchange.vue?vue&type=template&id=500d43b8"
import script from "./approveExchange.vue?vue&type=script&lang=js"
export * from "./approveExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports